import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MatPaginatorIntlService implements MatPaginatorIntl {
    changes = new Subject<void>();
    firstPageLabel: string = '';
    itemsPerPageLabel: string = '';
    lastPageLabel: string = '';
    nextPageLabel: string = '';
    previousPageLabel: string = '';
    onePage: string = '';
    page: string = '';
    of: string = '';

    constructor(
        private readonly destroyRef: DestroyRef,
        private readonly translateService: TranslateService
    ) {
        this.translateTexts();

        this.translateService.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.changes.next(); // Manually trigger the refresh when language is changed
            });
    }

    translateTexts() {
        this.translateService
            .stream('paginator.firstPageLabel')
            .subscribe((data) => (this.firstPageLabel = data));

        this.translateService
            .stream('paginator.itemsPerPageLabel')
            .subscribe((data) => (this.itemsPerPageLabel = data));

        this.translateService
            .stream('paginator.lastPageLabel')
            .subscribe((data) => (this.lastPageLabel = data));

        this.translateService
            .stream('paginator.nextPageLabel')
            .subscribe((data) => (this.nextPageLabel = data));

        this.translateService
            .stream('paginator.previousPageLabel')
            .subscribe((data) => (this.previousPageLabel = data));

        this.translateService
            .stream('paginator.onePage')
            .subscribe((data) => (this.onePage = data));

        this.translateService
            .stream('paginator.multiplePages.page')
            .subscribe((data) => (this.page = data));

        this.translateService
            .stream('paginator.multiplePages.of')
            .subscribe((data) => (this.of = data));
    }

    getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return `${this.page} 1 ${this.of} 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return `${this.page} ${page + 1} ${this.of} ${amountPages}`;
    }
}
